module.exports = __webpack_public_path__ + "img/sample.46cebaaa.png";